import { create } from 'zustand';
import { ORDEN_INICIAL } from '@/lib/orden-vehiculos';

interface VehicleFiltersState {
  filters: Record<string, any>;
  priceRange: [number, number];
  sortOrder: string;
  searchQuery: string;
  setFilters: (filters: Record<string, any>) => void;
  setPriceRange: (range: [number, number]) => void;
  setSortOrder: (order: string) => void;
  setSearchQuery: (query: string) => void;
  clearFilters: (maxPrice: number) => void;
}

const useVehicleFiltersStore = create<VehicleFiltersState>((set) => ({
  filters: {},
  priceRange: [0, 0],
  // Ticket #164: el listado abre en el orden INICIAL, que es el que configuró
  // la automotora. Antes arrancaba fijo en 'date_desc'.
  sortOrder: ORDEN_INICIAL,
  searchQuery: '',
  setFilters: (filters) => set({ filters }),
  setPriceRange: (priceRange) => set({ priceRange }),
  setSortOrder: (sortOrder) => set({ sortOrder }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  // "Limpiar filtros" saca lo que ACOTA el listado (filtros, precio y
  // búsqueda). El orden no acota nada —es cómo se mira la misma lista— y por
  // eso se conserva: quien ordenó por precio y limpia las marcas sigue viendo
  // la lista por precio. Por lo mismo, tampoco cuenta como filtro activo.
  clearFilters: (maxPrice) =>
    set({
      filters: {},
      priceRange: [0, maxPrice],
      searchQuery: '',
    }),
}));

export default useVehicleFiltersStore;
